export default "__VITE_ASSET__iAQTOYt8__"